import React from 'react';

interface Props {
  rating: number;
  count?: number;
  size?: number;
}

const StarRating: React.FC<Props> = ({ rating, count, size = 14 }) => {
  const stars = Array.from({ length: 5 }, (_, i) => {
    const filled = i < Math.floor(rating);
    const half = !filled && i < rating;
    return { filled, half };
  });

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
      {stars.map((s, i) => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" fill={s.filled ? '#f59e0b' : s.half ? 'url(#half)' : 'none'} stroke="#f59e0b" strokeWidth="1.5">
          <defs>
            <linearGradient id="half">
              <stop offset="50%" stopColor="#f59e0b" />
              <stop offset="50%" stopColor="transparent" />
            </linearGradient>
          </defs>
          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
        </svg>
      ))}
      {count != null && (
        <span style={{ fontSize: size - 2, color: '#6b7280', marginLeft: 4 }}>({count})</span>
      )}
    </span>
  );
};

export default StarRating;
